import { supabase } from '../lib/supabase';

// Thin wrapper over the `ops-stats` edge function. The function enforces
// auth + the OPS_ADMIN_EMAILS allowlist server-side; the frontend adds a
// matching check so unauthorised users never see the page shell flash.

async function invoke(body) {
  const { data, error } = await supabase?.functions?.invoke('ops-stats', { body: body || {} });
  if (error) {
    let details = error?.message || 'Ops stats call failed';
    try {
      const ctx = error?.context;
      if (ctx && typeof ctx?.json === 'function') {
        const errBody = await ctx.json();
        if (errBody?.error) details = errBody.error;
      }
    } catch (_) { /* ignore */ }
    return { data: null, error: { message: details } };
  }
  return { data, error: null };
}

export const opsService = {
  getOverview() {
    return invoke({});
  },
  getCompanyDetail(companyId) {
    if (!companyId) return Promise.resolve({ data: null, error: { message: 'companyId required' } });
    return invoke({ companyId });
  },
};
